import i18n from 'i18next';
import * as Yup from 'yup';

export const CreateUserSchema = (t: typeof i18n.t, editAction?: boolean) =>
  Yup.object().shape({
    name: Yup.string().min(2, t('Too Short!')).max(50, t('Too Long!')).required(t('Name & Surname are required')),
    email: Yup.string().email(t('Invalid e-mail address')).required(t('Email is required')),
    password: editAction ? Yup.string() : Yup.string().required(t('Password is required')),
  });
